import type { FeatureDefinition } from "../types"

// Use this array to add new desktop features with controllable rollout percentage
export const DESKTOP_FEATURES: FeatureDefinition[] = [
  {
    id: "error-guard-retry-v2",
    displayName: "Enhanced error guard retry mechanism",
    description: "Now correctly retries idempotent requests using exponential backoff on network errors",
  },
  {
    id: "endgame-errors-debug",
    displayName: "Endgame errors debug",
    description: "Feature that tracks game launches, exits, and match starts and ends, \
    and dumps interesting logs on matchId or gameId mismatch errors from endgame transaction.",
  },
  {
    id: "endgame-screen-ab-test",
    displayName: "Endgame screen AB test",
    description: "Feature that allows to test new endgame screen AB test.\
    100% rollout - means that all users will see the new endgame screen.",
  },
  {
    id: "rewarded-ads",
    displayName: "Rewarded Ads",
    description: "Controls the rewarded video ads feature in the desktop app (overlay, marketplace card, endgame/gameSummary banners).",
  },
  {
    id: "trinity-tts",
    displayName: "Trinity TTS",
    description: "Enables the Trinity TTS feature in the desktop app.",
  },
  {
    id: "matchRecording",
    displayName: "Match Recording (per-match video + session log capture)",
    description: "Gates the Buff per-match recording feature. Each opted-in user records a 1080p video of every match \
    plus a synchronized session-event log used for ML training. The recording behaviour is further tuned in \
    Settings → Match Recording. Start at 0% and gradually roll out; the admin-level kill switch in the Match Recording \
    page works independently of this flag.",
  },
  {
    id: "app-logs-upload-on-failure",
    displayName: "App logs upload on recording-upload failure",
    description: "When a recording upload fails, the desktop app automatically uploads the user's Overwolf client logs \
    so engineers can diagnose the failure. Uploads are coalesced (one per burst of failures) and rate-limited to at most \
    once per hour.",
  },
  {
    id: "match-recording-indicator",
    displayName: "Match Recording live indicator (internal)",
    description: "Shows a blinking 'RECORDING' indicator with an elapsed timer in the desktop app top bar while a \
    match capture is actively recording. Internal-only diagnostic — scope it to a single country (VN) at 100%. \
    Independent of the `matchRecording` capture flag: this only controls the indicator UI, not whether recording happens. \
    Country-targeted flags only evaluate for authenticated users, and rollout percentage must be high enough to pass the \
    bucket before the country whitelist is reached.",
  },
]
